import messages from '../locales/messages';
import { FormattedMessage } from 'react-intl';

export default {
  //header
  header: {
    headerTitle: <FormattedMessage {...messages.headerTitle} />,
    headerText: <FormattedMessage {...messages.headerText} />,
  },
  //forms
  forms: {
    title1: <FormattedMessage {...messages.title1} />,
    input1: <FormattedMessage {...messages.input1} />,
    input2: <FormattedMessage {...messages.input2} />,
    input3: <FormattedMessage {...messages.input3} />,
    title2: <FormattedMessage {...messages.title2} />,
    bar1: <FormattedMessage {...messages.bar1} />,
    bar2: <FormattedMessage {...messages.bar2} />,
    bar3: <FormattedMessage {...messages.bar3} />,
    upBar1: <FormattedMessage {...messages.upBar1} />,
    upBar2: <FormattedMessage {...messages.upBar2} />,
    upBar3: <FormattedMessage {...messages.upBar3} />,
  },
  //results
  results: {
    resultsTitle: <FormattedMessage {...messages.resultsTitle} />,
    resultsText: <FormattedMessage {...messages.resultsText} />,
    reduceVolume: <FormattedMessage {...messages.reduceVolume} />,
    reduceHandle: <FormattedMessage {...messages.reduceHandle} />,
    reduceAdmin: <FormattedMessage {...messages.reduceAdmin} />,
    savings: <FormattedMessage {...messages.savings} />,
  },
};
